import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export var Objects;

(function (Objects) {
  /**
   * Creates a unique string based on contents of an object.
   * Can be used as a dependency for hooks which take non-memoized objects as a parameter.
   * @param object The object to create a content dependency for
   */
  function contentDependency(object) {
    if (!object) {
      return '';
    }

    if (Array.isArray(object)) {
      return JSON.stringify(_toConsumableArray(object).sort());
    }

    return JSON.stringify(Object.keys(object).sort().reduce(function (memo, key) {
      return Object.assign(Object.assign({}, memo), _defineProperty({}, key, object[key]));
    }, {}));
  }

  Objects.contentDependency = contentDependency;
  /** Check if an object is an object and is not an array */

  function isObject(item) {
    return !!item && typeof item === 'object' && !Array.isArray(item);
  }

  Objects.isObject = isObject;

  function mergeDeepFromKeyChain(target, keyChain, value) {
    var output = Array.isArray(target) || Number.isInteger(keyChain === null || keyChain === void 0 ? void 0 : keyChain[0]) ? _toConsumableArray(target || []) : Object.assign({}, target || {});
    var bookmarkRef = output;

    for (var i = 0; i < keyChain.length; i += 1) {
      var key = keyChain[i];

      if (i === keyChain.length - 1) {
        if (Array.isArray(value)) {
          bookmarkRef[key] = _toConsumableArray(value);
        } else if (typeof value === 'object') {
          bookmarkRef[key] = Object.assign({}, value);
        } else {
          bookmarkRef[key] = value;
        }
      } else if (Array.isArray(bookmarkRef[key])) {
        bookmarkRef[key] = _toConsumableArray(bookmarkRef[key]);
        bookmarkRef = bookmarkRef[key];
      } else if (typeof bookmarkRef[key] === 'object') {
        bookmarkRef[key] = Object.assign({}, bookmarkRef[key]);
        bookmarkRef = bookmarkRef[key];
      } else if (Number.isInteger(key)) {
        bookmarkRef[key] = _toConsumableArray(bookmarkRef[key]);
        bookmarkRef = bookmarkRef[key];
      } else {
        bookmarkRef[key] = Object.assign({}, bookmarkRef[key]);
        bookmarkRef = bookmarkRef[key];
      }
    }

    return output;
  }

  Objects.mergeDeepFromKeyChain = mergeDeepFromKeyChain;
  /** Perform an operation on the keys of an object and return an array of the results */

  Objects.mapKeys = function (object, callback) {
    return Object.keys(object).map(function (key, index) {
      return callback(key, object[key], index);
    });
  };
  /** Perform an operation on the keys of an object */


  Objects.forEachKeys = function (object, callback) {
    return Object.keys(object).forEach(function (key, index) {
      return callback(key, object[key], index);
    });
  };
  /**
   * Deep merge two objects.
   * @param target The target object to merge into
   * @param source The new source objects
   */


  function mergeDeep(target) {
    if (!isObject(target)) {
      return target;
    }

    var newTarget = Object.assign({}, target);

    for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }

    var _loop = function _loop() {
      var source = _sources[_i];

      if (isObject(source)) {
        Object.keys(source).forEach(function (key) {
          var targetValue = newTarget[key];
          var sourceValue = source[key];

          if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
            newTarget[key] = [].concat(_toConsumableArray(targetValue), _toConsumableArray(sourceValue));
          } else if (isObject(targetValue) && isObject(sourceValue)) {
            newTarget[key] = mergeDeep(targetValue, sourceValue);
          } else {
            newTarget[key] = sourceValue;
          }
        });
      }
    };

    for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
      _loop();
    }

    return newTarget;
  }

  Objects.mergeDeep = mergeDeep;
})(Objects || (Objects = {}));